/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';

/**
 * The player's KYC verification pointer surfaced on the player-details screen: the pam_player
 * id (the KYC-detail link target) and current verification status.
 * Null/absent when the player has no KYC record.
 * @export
 * @interface PamPlayerVerificationSummary
 */
export interface PamPlayerVerificationSummary {
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamPlayerVerificationSummary
     */
    status: PamPlayerVerificationStatus;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PamPlayerVerificationSummary
     */
    pamPlayerId: string;
}



/**
 * Check if a given object implements the PamPlayerVerificationSummary interface.
 */
export function instanceOfPamPlayerVerificationSummary(value: object): value is PamPlayerVerificationSummary {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('pamPlayerId' in value) || value['pamPlayerId'] === undefined) return false;
    return true;
}

export function PamPlayerVerificationSummaryFromJSON(json: any): PamPlayerVerificationSummary {
    return PamPlayerVerificationSummaryFromJSONTyped(json, false);
}

export function PamPlayerVerificationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamPlayerVerificationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PamPlayerVerificationStatusFromJSON(json['status']),
        'pamPlayerId': json['pamPlayerId'],
    };
}

export function PamPlayerVerificationSummaryToJSON(value?: PamPlayerVerificationSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': PamPlayerVerificationStatusToJSON(value['status']),
        'pamPlayerId': value['pamPlayerId'],
    };
}

